var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.$vuetify.breakpoint.xsOnly)?_c('pc'):_c('movil')
}
var staticRenderFns = []

export { render, staticRenderFns }